import React, { useEffect, useState, useContext } from 'react'
import { Row, Col, Card, CardHeader, CardBody } from 'reactstrap'
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import config from '../../../config';
import CustomizerContext from "../../../_helper/Customizer";


const BackendHomeView = () => {

    const token = localStorage.getItem("sessiontoken");
    const configheader = {
        headers: {
            Authorization: token
        }
    };

    const navigate = useNavigate();
    const { layoutURL } = useContext(CustomizerContext);
    const login_id = localStorage.getItem("loginId");
    const [concessionaires, setConcessionaires] = useState([])
    const deletePermission = localStorage.getItem("dataDeletePermission")

    useEffect(() => {
        axios
            .post(`${config.hostname}/users/getconcessionaireaccess`, { user_id: login_id }, configheader)
            .then((response) => {
                setConcessionaires(response.data.concessionaire_access);
            })
            .catch((error) => {
                console.log(error);
            });
    }, [])

    const handleCardClick = (concessionaireId, dataMode, concessionaireName, auditRequired, auditTolerance, auditIndividualTenants) => {
        localStorage.setItem('concessionaireId', concessionaireId);
        localStorage.setItem('concessionaireName', concessionaireName);
        localStorage.setItem("accessDashboard", "1")
        localStorage.setItem("accessAnalytics", "1")
        localStorage.setItem("accessReports", "1")
        localStorage.setItem("accessRevenueReports", "1")
        localStorage.setItem("accessDataGrid", "1")
        localStorage.setItem("accessGeneralSettings", "1")
        localStorage.setItem("manageGeneralSettings", "1")
        localStorage.setItem("accessTenants", "1")
        localStorage.setItem("manageTenants", "1")
        localStorage.setItem("manageConfigurations", "1")
        localStorage.setItem("manageUsers", "1")
        localStorage.setItem("manageUserProfile", "1")
        localStorage.setItem("accessLogs", "1")
        localStorage.setItem("manageScheduleReports", "1");
        localStorage.setItem("tenantPortalManage", "1");
        localStorage.setItem("dataMode", dataMode);
        localStorage.setItem("auditRequired", auditRequired ? "true" : "false");
        localStorage.setItem("auditTolerance", auditTolerance ?? "0");
        localStorage.setItem("auditIndividualTenants", auditIndividualTenants ? "true" : "false");
        localStorage.setItem("bulkDataUpload", "1")
        localStorage.setItem("accessAudit", "1")
        // navigate(`${process.env.PUBLIC_URL}/admin/dashboard/sales/${layoutURL}`); //admin
        window.location.href = `${process.env.PUBLIC_URL}/admin/dashboard/sales/${layoutURL}`
    };

    const handleViewAPIKey = () => {
        navigate(`${process.env.PUBLIC_URL}/admin/viewapikey/${layoutURL}`);
    }

    const handleDeleteData = () => {
        navigate(`${process.env.PUBLIC_URL}/admin/deletedata/${layoutURL}`);
    }
    return (
        // <>

        //     <Col className="d-flex justify-content-end align-items-center">
        //         <button
        //             className="btn btn-primary btn-lg w-100"
        //             style={{ maxWidth: "220px" }}
        //             onClick={handleViewAPIKey}
        //         >
        //             View API Key
        //         </button>
        //     </Col>

        //     {deletePermission === "true" && (
        //         <Col className="d-flex justify-content-end align-items-center mt-4">
        //             <button
        //                 className="btn btn-danger btn-lg w-100"
        //                 style={{ maxWidth: "220px" }}
        //                 onClick={handleDeleteData}
        //             >
        //                 Delete Data
        //             </button>
        //         </Col>
        //     )}

        //     {concessionaires.map((concessionaire) => (
        //         <Col key={concessionaire._id} className='col-xxl-4 col-sm-6 box-col-6'>
        //             <Card className='profile-box' style={{ cursor: 'pointer' }} onClick={() => handleCardClick(concessionaire._id, concessionaire.data_mode, concessionaire.concessionaire_name)}>
        //                 <CardBody>
        //                     <h5>{concessionaire.concessionaire_name}</h5>
        //                 </CardBody>
        //             </Card>
        //         </Col>
        //     ))}

        // </>
        <Row>
            {/* Left Column: Concessionaire Cards */}
            <Col md={8} sm={12}>
                {concessionaires.map((concessionaire) => (
                    <Col
                        key={concessionaire._id}
                        className="col-12 mb-3" // full width card, with margin
                    >
                        <Card
                            className="profile-box"
                            style={{ cursor: "pointer" }}
                            onClick={() =>
                                handleCardClick(
                                    concessionaire._id,
                                    concessionaire.data_mode,
                                    concessionaire.concessionaire_name,
                                    concessionaire.audit_required,
                                    concessionaire.audit_tolerance,
                                    concessionaire.audit_individual_tenants,
                                )
                            }
                        >
                            <CardBody>
                                <h5 className="mb-0">{concessionaire.concessionaire_name}</h5>
                            </CardBody>
                        </Card>
                    </Col>
                ))}
            </Col>

            {/* Right Column: Buttons */}
            <Col
                md={4}
                sm={12}
                className="d-flex flex-column justify-content-start align-items-end"
            >
                <button
                    className="btn btn-primary btn-lg w-100 mb-4"
                    style={{ maxWidth: "220px" }}
                    onClick={handleViewAPIKey}
                >
                    View API Key
                </button>

                {deletePermission === "true" && (
                    <button
                        className="btn btn-danger btn-lg w-100"
                        style={{ maxWidth: "220px" }}
                        onClick={handleDeleteData}
                    >
                        Delete Data
                    </button>
                )}
            </Col>
        </Row>

    )
}

export default BackendHomeView